import type { CurrentRead } from '@signalvote/data';
import type { FinanceSettingsDto } from '@signalvote/shared';

/** The finance settings read; null data means the committee has saved none yet. */
export type FinanceSettingsRead = CurrentRead<FinanceSettingsDto | null>;

/** The settings once their read has answered; undefined while it loads, has not run, or could not answer. */
export function readySettings(read: FinanceSettingsRead): FinanceSettingsDto | null | undefined {
  return read.status === 'ready' ? read.data : undefined;
}

/** What to say in place of the settings when their read could not answer; null otherwise. */
export function settingsUnreadyMessage(read: FinanceSettingsRead): string | null {
  if (read.status === 'offline') return "You're offline, so your finance settings can't load.";
  if (read.status === 'failed') return "Couldn't load your finance settings. Refresh to try again.";
  return null;
}
